export const menuData = [
    { title: 'Sobre', link: 'about-section' },
    { title: 'Galeria', link: 'galery-section' },
    { title: 'Contato', link: 'contact-section' },
];